import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';

@Injectable()
export default class MockOauthService extends OAuthService {
  override async loadDiscoveryDocumentAndTryLogin() {
    return true;
  }
  override initLoginFlow() {
    return;
  }
  override configure() {
    return;
  }
  override setupAutomaticSilentRefresh() {
    return;
  }
  override logOut() {
    return;
  }
}
